import { useEffect } from 'react';
import { toast } from 'sonner';

const MAIN_RE = /\/static\/js\/main\.[a-f0-9]+\.js/;
const BUILD_KEY = 'capex_build';
const NOTICE_KEY = 'capex_update_notice';

const currentBuild = () => {
  const s = document.querySelector('script[src*="/static/js/main."]');
  const m = s && s.getAttribute('src').match(MAIN_RE);
  return m ? m[0] : null;
};

const forceLogout = (build) => {
  localStorage.removeItem('capex_token');
  localStorage.setItem(BUILD_KEY, build);
  sessionStorage.setItem(NOTICE_KEY, '1');
  window.location.replace('/login');
};

// Déconnecte tout le monde après chaque publication pour que chacun recharge la nouvelle version.
export const VersionWatcher = () => {
  useEffect(() => {
    if (sessionStorage.getItem(NOTICE_KEY)) {
      sessionStorage.removeItem(NOTICE_KEY);
      toast.info("Une nouvelle version de CAPEX vient d'être installée : merci de vous reconnecter.", { duration: 8000 });
    }
    const loaded = currentBuild();
    if (!loaded) return undefined; // mode développement : pas de hash de build
    const stored = localStorage.getItem(BUILD_KEY);
    if (stored && stored !== loaded && localStorage.getItem('capex_token')) {
      forceLogout(loaded);
      return undefined;
    }
    localStorage.setItem(BUILD_KEY, loaded);

    const check = async () => {
      try {
        const html = await (await fetch(`/?v=${Date.now()}`, { cache: 'no-store' })).text();
        const m = html.match(MAIN_RE);
        if (m && m[0] !== loaded) forceLogout(m[0]);
      } catch { /* hors ligne : on réessaiera */ }
    };
    const id = setInterval(check, 5 * 60 * 1000);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    return () => { clearInterval(id); document.removeEventListener('visibilitychange', onVisible); };
  }, []);
  return null;
};
